
import 'jquery';

/** Browser and operating system environment */
/** Is current operating system Windows 10? */
export function IsWindows10() {
    var osStr = navigator.appVersion + (<any>navigator).oscpu; // IE11 puts OS info in appVersion, Firefox in oscpu
    var isWin10 = osStr.indexOf("Windows NT 10.0") >= 0 ||
        osStr.indexOf("Windows 10.0") >= 0;
    return isWin10;
}

/** Is current browser IE11? Depending on kendo! */
export function IsIE11() {
    const root = $(":root");
    var isIE11 = root.hasClass("k-ie") || root.hasClass("k-ie11");
    return isIE11;
}

/** Is current browser Firefox? Depending on kendo! */
export function IsFirefox() {
    var isFF = $(":root").hasClass("k-ff");
    return isFF;
}

/** Is current browser Chrome? Depending on kendo! */
export function IsChrome() {
    var isChrome = $(":root").hasClass("k-webkit");
    return isChrome;
}

export function IsSafari() {
    return kendo.support.browser.safari;
}

/**
 * Detects if the current browser is on a mobile device.
 * (analagous with PDFTron ...)
 */
export function isMobileDevice() {
    if (_isMobileDevice === undefined) {
        if (isIE())
            return _isMobileDevice = false;

        const userAgent = navigator.userAgent;
        if (userAgent.match(/Edge/i) && scrollbarWidth() === 0)
            return _isMobileDevice = true;

        const mCount = mobileUserAgents.length;
        for (var i = 0; i < mCount; i++) {
            if (userAgent.match(mobileUserAgents[i])) {
                return _isMobileDevice = true;
            }
        }
        return _isMobileDevice = false;
    }
    return _isMobileDevice;
}
var _isMobileDevice: boolean = undefined;

const mobileUserAgents = [
    // /Edge/i see above
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPod/i,
    /iPad/i,
    /Touch/i,
    /IEMobile/i,
    /Silk/i];

// In windows 10 tablets, the tablet mode and desktop mode use the same user agent.  HOWEVER
// the scrollbar width in tablet mode is 0. This means that we can find the scrollbar width
// and use it to determine if they are in tablet mode (mobile viewer) or desktop mode
function scrollbarWidth() {
    if (typeof _scrollbarWidth !== "number") {
        var scrollDiv = document.createElement('div');
        scrollDiv.style.cssText = 'width:100px;height:100px;overflow:scroll !important;position:absolute;top:-9999px';
        document.body.appendChild(scrollDiv);
        _scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
    }
    return _scrollbarWidth;
}
var _scrollbarWidth: number;

function isIE() {
    var ua = navigator.userAgent.toLowerCase();
    var match = /(msie) ([\w.]+)/.exec(ua) || /(trident)(?:.*? rv:([\w.]+)|)/.exec(ua);
    return match ? parseInt(match[2], 10) : match;
}

/** Normalized (browser and OS independent) outer window position and size */
export interface IWindowBounds {
    x: number;
    y: number;
    width: number;
    height: number;
}

/** Raw window position and size properties */
export interface IRawWindowBounds {
    /**
    * Minimized state of the window
    * Calculation by: document.visibilityState == "hidden" || document.hidden || (posx == -32000 && posy == -32000)
    * Minimized state can also be determined by window position in IE11
    */
    IsMinimized: boolean;
    /** Available width of the current window's screen */
    ScreenWidth: number;
    /** Available height of the current window's screen */
    ScreenHeight: number;
    /** Absolute x position of the window content */
    ContentX: number;
    /** Absolute y position of the window content */
    ContentY: number;
    /** Window content width (without toolbars and borders) */
    ContentWidth: number;
    /** Window content height (without toolbars and borders) */
    ContentHeight: number;
    /** Browser window outer width (including toolbars and borders) */
    WindowWidth: number;
    /** Browser window outer height (including toolbars and borders) */
    WindowHeight: number;
    /** Absolute outer window x position */
    WindowX: number;
    /** Absolute outer window y position */
    WindowY: number;
}

export function GetRawWindowBounds(window: Window) {
    var posx = window.screenX;
    var posy = window.screenY;
    var isMinimized = document.visibilityState == "hidden" || document.hidden || (posx == -32000 && posy == -32000);

    var rawWindowBounds: IRawWindowBounds = {
        IsMinimized: isMinimized,
        ScreenWidth: window.screen.availWidth,
        ScreenHeight: window.screen.availHeight,
        ContentX: !isNaN(window.screenLeft) ? window.screenLeft : window.mozInnerScreenX, // Attention: Chrome uses window position (not inner content)
        ContentY: !isNaN(window.screenTop) ? window.screenTop : window.mozInnerScreenY, // Attention: Chrome uses window position (not inner content)
        ContentWidth: window.innerWidth,
        ContentHeight: $(window).height(),
        WindowWidth: window.outerWidth,
        WindowHeight: window.outerHeight,
        WindowX: posx,
        WindowY: posy
    };
    return rawWindowBounds;
}

/** Determine if the window position or size has changed */
export function HasWindowBoundsChanged(windowBounds1: IRawWindowBounds, windowBounds2: IRawWindowBounds) {
    if (!windowBounds1 || !windowBounds2)
        return true;

    return windowBounds1.WindowX != windowBounds2.WindowX ||
        windowBounds1.WindowY != windowBounds2.WindowY ||
        windowBounds1.WindowWidth != windowBounds2.WindowWidth ||
        windowBounds1.WindowHeight != windowBounds2.WindowHeight;
}

/** Calculates real window size and position depending on browser and OS */
export function GetWindowBounds(rawWindowBounds: IRawWindowBounds): IWindowBounds {
    if (!rawWindowBounds)
        return null;

    // Window position
    var posx = rawWindowBounds.WindowX;
    var posy = rawWindowBounds.WindowY;

    // Correction of wrong content position (Chrome uses window position instead)
    // See: http://stackoverflow.com/questions/13254070/how-do-i-get-the-viewport-position-relative-to-the-screen
    var borderWidth = (rawWindowBounds.WindowWidth - rawWindowBounds.ContentWidth) / 2;
    var isContentPositionValid = (rawWindowBounds.ContentX == (rawWindowBounds.WindowX + borderWidth)) &&
        (rawWindowBounds.ContentY == (rawWindowBounds.WindowY + rawWindowBounds.WindowHeight - rawWindowBounds.ContentHeight - borderWidth) ||
            rawWindowBounds.ContentY != rawWindowBounds.WindowY);
    if (!rawWindowBounds.IsMinimized && !isContentPositionValid) {
        var newContentX = rawWindowBounds.WindowX + borderWidth;
        var newContentY = rawWindowBounds.WindowY + rawWindowBounds.WindowHeight - rawWindowBounds.ContentHeight - borderWidth;

        rawWindowBounds.ContentX = newContentX;
        rawWindowBounds.ContentY = newContentY;
    }

    // Don't save wrong minimized size
    if (rawWindowBounds.IsMinimized) {
        return null;
    } else {
        // Environment
        var isChrome = IsChrome();
        var isWin10 = IsWindows10();

        // Window size
        var currentScreenWidth = window.screen.availWidth;
        var currentScreenHeight = window.screen.availHeight;
        var innerWidth = rawWindowBounds.ContentWidth; // = Browser window (inner) width = $(window).width() = $(window).innerWidth() = $(window).outerWidth() = window.outerWidth - 2*sideBorder
        var outerWidth = rawWindowBounds.WindowWidth; // = Real browser window (outer) width = window.innerWidth + 2*sideBorder
        var widthDiff = outerWidth - innerWidth;
        var innerHeight = rawWindowBounds.ContentHeight;
        var outerHeight = rawWindowBounds.WindowHeight; // = Real browser window content (inner) width = window.innerWidth + 2*sideBorder
        var heightDiff = outerHeight - innerHeight;

        // Window border
        var sideBorder = (rawWindowBounds.ContentX - rawWindowBounds.WindowX) || 8; // IE11 = 8
        var topBorder = (rawWindowBounds.ContentY - rawWindowBounds.WindowY) || 31; // IE11 = 31

        // Window state (ATTENTION: Assuming that current screen is primary screen)
        var isMaxedOnPrimaryScreen = (posx == -sideBorder) && (posy == -sideBorder) ||
            (isChrome && (posx == 0 && posy == 0 && outerWidth == currentScreenWidth && outerHeight == currentScreenHeight)); // Chrome has no negative position on maximized!
        var isMaxedOnLeftScreen = (posx + sideBorder < 0) && (posy == -sideBorder);

        var isMaxedOnRightScreen = ((posx + sideBorder) == currentScreenWidth) && (posy == -sideBorder) ||
            (isChrome && posx == currentScreenWidth && posy == 0 && rawWindowBounds.WindowWidth == rawWindowBounds.ScreenWidth && rawWindowBounds.WindowHeight == rawWindowBounds.ScreenHeight);
        var isMaximized = isMaxedOnPrimaryScreen || isMaxedOnLeftScreen || isMaxedOnRightScreen;

        // If this window is maximized, this state can only be emulated by a window with the same size.
        // In maximized state the size is +widthDiff of the real size and pos is -sideBorder (but not in Chrome and Windows 10 ;-)).
        if (isMaximized && !isChrome && !isWin10) {
            // Calculate the real size
            innerWidth -= widthDiff;
            outerWidth -= widthDiff;
            innerHeight -= widthDiff;
            outerHeight -= widthDiff;
            posx += sideBorder;
            posy += sideBorder;
        } else if (isMaximized && isWin10) {
            posy += sideBorder; // Holy crap! But the titlebar is smaller in maximized mode in Windows 10!
        }

        var windowBounds: IWindowBounds = { x: posx, y: posy, width: innerWidth, height: innerHeight };

        return windowBounds;
    }
}

export interface IWindowPosition {
    Offset: { left: number, top: number },
    Size: { width: number, height: number }

}

export function NormalizePosInfo(info: IWindowPosition | IWindowBounds) {
    function IsWindowPosition(check: any) : check is IWindowPosition {
        const t : IWindowPosition = check;
        return typeof t?.Offset?.left == "number";
    }
    function IsWindowBounds(check: any) : check is IWindowBounds {
        const t : IWindowBounds = check;
        return typeof t?.height== "number" && typeof t?.y == "number";
    }

    if(IsWindowBounds(info)) {
        return <IWindowBounds>{
            x : info.x,
            y : info.y,
            height : info.height,
            width : info.width
        };
    }

    if(IsWindowPosition(info)) {
        return <IWindowBounds>{
            width : info.Size.width,
            height : info.Size.height,
            x : info.Offset.left,
            y : info.Offset.top
        }
    }
}
/** Calculates window.open() parameter size and position depending on browser and OS */
export function GetWindowOpenBounds(windowBounds: IWindowBounds): IWindowBounds {
    // There is a difference between the browser window.open() behaviors.
    var isIE11 = IsIE11();
    //var isFF = environment.IsFirefox();
    //var isChrome = environment.IsChrome();

    // IE11 on Windows 8.1 has a window.open width and height difference of -4px
    // Chrome only needs size substraction in maximized mode. If the window does not fill the available space, the size must be kept!
    // Unresolved Windows 10 Issue: FireFox fullscreen emulation cannot be emulated! The surrounding margin is kept!
    var browserSizeWidth = isIE11 ? -4 : 0; // Chrome maximized mode: (isChrome ? -10 : 0)
    var browserSizeHeight = isIE11 ? -4 : 0; // Chrome maximized mode: (isChrome ? -7 : 0)

    var width = windowBounds.width + browserSizeWidth;
    var height = windowBounds.height + browserSizeHeight;
    var offsetX = Math.max(windowBounds.x, 0);
    var offsetY = Math.max(windowBounds.y, 0);

    var browserDependentWindowBounds: IWindowBounds = { x: offsetX, y: offsetY, width: width, height: height };
    return browserDependentWindowBounds;
}
